export default __webpack_public_path__ + "static/media/tbg.a75a0c01.png";